<template>
  <div>
    <vs-popup :title="$t('CreateSerial')" :active.sync="showModal">
      <form>
        <div class="flex mb-8 gap-3 gap-y-5 flex-wrap">
          <div class="lg:w-1/2 w-full flex flex-col gap-2 relative">
            <vs-input
              class="inputx"
              v-model="info.serial"
              name="serialName"
              :label="$t('SerialNumber')"
              v-validate="'required'"
              :disabled="!AbilityAddSerial"
            />
            <span
              class="text-danger text-sm absolute"
              style="top: 62px"
              v-show="errors.has('serialName')"
              >{{ errors.first("serialName") }}</span
            >
          </div>
          <div class="flex-grow flex flex-col gap-2 relative">
            <vs-input
              class="inputx"
              v-model="info.trackingId"
              name="trackingId"
              :label="$t('TrackingId')"
              v-validate="{ required: true, regex: '^([0-9]+)$' }"
              :disabled="!AbilityAddSerial"
            />
            <span
              class="text-danger text-sm absolute"
              style="top: 62px"
              v-show="errors.has('trackingId')"
              >{{ errors.first("trackingId") }}</span
            >
          </div>
          <div
            class="lg:w-1/2 lg:flex-grow-0 flex-grow flex flex-col gap-2 relative"
          >
            <vs-input
              class="inputx"
              v-model="info.identificationCode"
              name="identificationCode"
              :label="$t('IdentificationCode')"
              v-validate="{ required: true, regex: '^([0-9]+)$' }"
              :disabled="!AbilityAddSerial"
            />
            <span
              class="text-danger text-sm absolute"
              style="top: 62px"
              v-show="errors.has('identificationCode')"
              >{{ errors.first("identificationCode") }}</span
            >
          </div>
          <div class="flex-grow flex flex-col gap-2 relative">
            <vs-input
              class="inputx"
              v-model="info.guaranteeIdentification"
              name="guaranteeIdentification"
              :label="$t('GuaranteeIdentification')"
              v-validate="{ required: true, regex: '^([0-9]+)$' }"
              :disabled="!AbilityAddSerial"
            />
            <span
              class="text-danger text-sm absolute"
              style="top: 62px"
              v-show="errors.has('guaranteeIdentification')"
              >{{ errors.first("guaranteeIdentification") }}</span
            >
          </div>
          <div class="w-10 flex justify-end items-end">
            <vs-button
              size="small"
              radius
              color="success"
              type="gradient"
              icon-pack="feather"
              icon="icon-plus"
              @click.prevent="addSerial()"
              class="mb-2 mt-2 lfloat"
              :disabled="!AbilityAddSerial"
            ></vs-button>
          </div>
        </div>
      </form>
      <div class="mt-10">
        <vs-table
          :data="selectedTransactionSerials"
          class="custom-tbl"
          id="serial-tbl"
        >
          <template slot="thead">
            <th>#</th>
            <th>{{ $t("SerialNumber") }}</th>
            <th>{{ $t("TrackingId") }}</th>
            <th>{{ $t("IdentificationCode") }}</th>
            <th>{{ $t("GuaranteeIdentification") }}</th>
            <th>{{ $t("Action") }}</th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr :key="i" v-for="(tr, i) in data">
              <vs-td style="width: 5%">
                {{ i + 1 }}
              </vs-td>
              <vs-td style="width: 20%">
                <vs-input
                  class="inputx edit serial-input"
                  :id="'Serial' + i"
                  disabled
                  v-model="tr.serial"
                />
              </vs-td>
              <vs-td style="width: 20%">
                <vs-input
                  class="inputx edit serial-input"
                  :id="'trackingId' + i"
                  disabled
                  v-model="tr.trackingId"
                />
              </vs-td>
              <vs-td style="width: 20%">
                <vs-input
                  class="inputx edit serial-input"
                  :id="'identificationCode' + i"
                  disabled
                  v-model="tr.identificationCode"
                />
              </vs-td>
              <vs-td style="width: 20%">
                <vs-input
                  class="inputx edit serial-input"
                  :id="'guaranteeIdentification' + i"
                  disabled
                  v-model="tr.guaranteeIdentification"
                />
              </vs-td>

              <vs-td style="width: 15%">
                <vs-button
                  radius
                  :color="onEdit ? 'success' : 'warning'"
                  size="small"
                  type="gradient"
                  icon-pack="feather"
                  icon="icon-edit"
                  @click.prevent="editSerial(i)"
                  class="ml-4 d-inline"
                ></vs-button>
                <vs-button
                  radius
                  color="danger"
                  size="small"
                  type="gradient"
                  icon-pack="feather"
                  icon="icon-x"
                  @click.prevent="deleteSerial(i)"
                  class="d-inline"
                ></vs-button>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>

      <vs-button
        type="filled"
        class="float-right mb-4 mt-4"
        @click.prevent="submitSerialForm"
        >{{ $t("Save") }}</vs-button
      >
    </vs-popup>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import { Validator } from "vee-validate";

const dict = {
  custom: {
    serialName: {
      required: "لطفا شماره سریال را وارد نمایید.",
    },
    trackingId: {
      regex: "لطفا فقط عدد وارد کنید",
      required: "لطفا شناسه رهگیری را وارد نمایید.",
    },
    identificationCode: {
      regex: "لطفا فقط عدد وارد کنید",
      required: "لطفا شناسه کالا را وارد نمایید.",
    },
    guaranteeIdentification: {
      required: "لطفا شناسه گارانتی را وارد نمایید.",
      regex: "لطفا فقط عدد وارد کنید",
    },
  },
};
Validator.localize("fa", dict);
export default {
  name: "warehouseManagement_CheckinTransactions_SerialPopup",
  props: {
    show: { default: false },
    serialsListSelected: { default: [] },
    transactionCount: 0,
  },
  data() {
    return {
      selectedTransactionSerials: [],
      onEdit: true,
      AbilityAddSerial: false,
      info: {
        serial: "",
        trackingId: "",
        identificationCode: "",
        guaranteeIdentification: "",
      },
      disabled: true,
    };
  },
  computed: {
    showModal: {
      get: function () {
        return this.show;
      },
      set: function () {
        this.$emit("finish");
        this.$validator.reset();
      },
    },
  },
  watch: {
    show() {
      if (this.show) {
        this.AbilityAddSerial = false;
        this.selectedTransactionSerials = this.serialsListSelected;
        if (this.serialsListSelected.length < this.transactionCount) {
          this.AbilityAddSerial = true;
        }
      }
    },
  },
  methods: {
    ...mapActions({
      // addSerialToSelectedTransaction:
      //   "checkInTransactions/addSerialToSelectedTransaction",
      // removeSerialFromSelectedTransaction:
      //   "checkInTransactions/removeSerialFromSelectedTransaction"
    }),
    editSerial(i) {
      var el1 = document.getElementById("Serial" + i);
      var el2 = document.getElementById("trackingId" + i);
      var el3 = document.getElementById("identificationCode" + i);
      var el4 = document.getElementById("guaranteeIdentification" + i);
      el1.disabled = !el1.disabled;
      el2.disabled = !el2.disabled;
      el3.disabled = !el3.disabled;
      el4.disabled = !el4.disabled;
    },
    addSerial() {
      console.log(this.errors);
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.selectedTransactionSerials.push({
            serial: this.info.serial,
            trackingId: Number(this.info.trackingId),
            identificationCode: Number(this.info.identificationCode),
            guaranteeIdentification: Number(this.info.guaranteeIdentification),
          });
          this.$validator.reset();
          this.info.serial = "";
          this.info.trackingId = "";
          this.info.identificationCode = "";
          this.info.guaranteeIdentification = "";
          if (this.transactionCount <= this.selectedTransactionSerials.length)
            this.AbilityAddSerial = false;
        }
      });
    },
    deleteSerial(index) {
      this.$swal({
        title: "آیا از حذف این رکورد اطمینان دارید؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بلی",
        cancelButtonText: "خیر",
      }).then((result) => {
        if (result.value) {
          this.selectedTransactionSerials.splice(index, 1);
          if (this.transactionCount != this.selectedTransactionSerials.length)
            this.AbilityAddSerial = true;
          this.$swal({
            position: "center-center",
            type: "success",
            text: "رکورد مورد‌نظر با موفقیت حذف شد!",
            showConfirmButton: false,
            timer: 2000,
          });
        }
      });
    },
    submitSerialForm() {
      // this.addSerialToSelectedTransaction(this.selectedTransactionSerials);
      // while (this.selectedTransactionSerials.includes("")) {
      //   this.selectedTransactionSerials.forEach((element, index) => {
      //     if (element == "") {
      //       this.removeSerialFromSelectedTransaction(index);
      //     }
      //   });
      // }
      this.$emit("updateSerialList", this.selectedTransactionSerials);

      delete this.selectedTransactionSerials;
      this.selectedTransactionSerials = [];

      this.$emit("finish");
      var elems = document.querySelectorAll('*[id^="Serial"]');
      elems.forEach((elem) => {
        elem.disabled = true;
      });
    },
  },
};
</script>

<style>
.theme-dark #serial-tbl .serial-input .vs-input--input:disabled {
  background: black !important;
}
</style>
